<template>
  <div class="integration-icon-table-cell">
    <div class='integration-icon-table-cell__icon' v-html="icon" v-if='icon'></div>
    <company-logo :domain="whiteLabelingConfig.domain" view="no_text" v-else-if="whiteLabelingConfig.domain"/>
    <cynergy-app-no-text v-else/>
  </div>
</template>

<script>
import CynergyAppNoText from '@/assets/icons/whitelabeling/cynergy.app/cynergy_app_no_text.svg?inline';
import CompanyLogo from '@/components/common/CompanyLogo.vue';
import {mapGetters} from 'vuex';

export default {
  name: 'IntegrationIconTableCell',
  components: {
    CynergyAppNoText,
    CompanyLogo,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['whiteLabelingConfig']),
    icon() {
      return this.item[this.column.name];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/design-system";

.integration-icon-table-cell {
  font-family: $font-family-regular;
  font-size: rem(14);
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--text-primary);
  &__icon {
    max-width: rem(24) !important;
    display: flex;
  }
  svg {
    width: rem(30);
    height: rem(30);
    display: inline-block;
  }
  img {
    width: rem(30);
    height: rem(30);
    display: inline-block;
  }
}

</style>
